import { useState, useEffect, useCallback } from 'react'
import { Participants, Parameters, Main, ParticipantsEmployees, Responsible } from './ModalTabs'
import Modal from 'react-responsive-modal'
import { EventsListModalModes, } from '../../assets/const'
import styles from './styles.module.scss'
import cn from 'classnames'
import { EventListContext } from '../../utils/context'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'
import { createEvent, updateEvent } from '../../actions/events_list'
import Confirmation from '../../components/Confirmation/Confirmation'

const getInitialValues = (event) => {
    const today = moment().format('YYYY-MM-DDTHH:mm:ss')
    return {
        main: {
            title: event?.title || '',
            date: event?.date,
            dend: event?.dend,
            author: event?.author || '',
            message: event?.message || '',
            show: event?.show ?? true,
            inner_event: event?.inner_event ?? true,
            acid: event?.acid,
            news_level_id: event?.news_level_id,
            edid: event?.edid,
            ev_type_id: event?.ev_type_id,
            included_in_md_plan: event?.included_in_md_plan ?? false,
            command_competition: event?.command_competition || 0,
            resp_kind: event?.resp_kind || 0,
            resp_subtype: event?.resp_subtype || 0,
            resp_result: event?.resp_result || 0,
            resp_desc1: event?.resp_desc1 || '',
            resp_desc2: event?.resp_desc2 || '',
            resp_subject: event?.resp_subject || '',
            resp_content: event?.resp_content || '',
            rid: event?.rid || '',
            planGUK: event?.planGUK ?? false,
            regular: event?.regular ?? false,
            cont_type: event?.cont_type || '',
            text: event?.text || ''
        },
        members: Array.isArray(event?.members) ? event.members : [],
        teachers: Array.isArray(event?.teachers) ? event.teachers : [],
        teacher_members: Array.isArray(event?.teacher_members) ? event.teacher_members : [],
        authors: Array.isArray(event?.authors) ? event.authors : [],
        achivements: Array.isArray(event?.achivements) ? event.achivements : [],
        class_gids: Array.isArray(event?.class_gids) ? event.class_gids : []
    }
}

const formatConflicts = (conflicts) =>
    (conflicts || [])
        .map(c => `«${c.title}» (${moment(c.date).format('DD.MM.YYYY HH:mm')} – ${moment(c.dend).format('DD.MM.YYYY HH:mm')}), место: ${c.author}`)
        .join('; ')

const validationSchema = Yup.object({
    main: Yup.object({
        title: Yup.string().required('Обязательное поле').max(100, 'Должно быть не более 100 символов'),
        date: Yup.string().required('Обязательное поле'),
        dend: Yup.string().required('Обязательное поле'),
        author: Yup.string().required('Обязательное поле'),
        acid: Yup.number().required('Обязательное поле'),
        news_level_id: Yup.number().required('Обязательное поле'),
        edid: Yup.number().required('Обязательное поле'),
        ev_type_id: Yup.number().required('Обязательное поле'),
    })
})

export default function ModalComponent({ event, isOpen, closeModal, filters }) {

    const dispatch = useDispatch()
    const [mode, setMode] = useState('main')

    const addMode = !event?.nid

    const [conflict, setConflict] = useState(null)

    const handleCreate = async (values) => {
        const result = await dispatch(createEvent(values, filters))
        if (result.success) {
            closeModal()
        } else if (result.conflict) {
            setConflict({ ...result, values })
        }
    }

    const handleUpdate = async (values) => {
        const result = await dispatch(updateEvent(event.nid, values, filters))
        if (result.success) {
            closeModal()
        } else if (result.conflict) {
            setConflict({ ...result, values })
        }
    }

    const formik = useFormik({
        initialValues: getInitialValues(event),
        enableReinitialize: true,
        validateOnChange: true,
        validationSchema,
        onSubmit: addMode ? handleCreate : handleUpdate
    })

    const handleForceSave = async () => {
        const result = addMode
            ? await dispatch(createEvent(conflict.values, filters, true))
            : await dispatch(updateEvent(event.nid, conflict.values, filters, true))
        setConflict(null)
        if (result.success) {
            closeModal()
        }
    }

    const [confirmation, setConfirmation] = useState(false)

    const handleClose = useCallback(() => {
        if (formik.dirty) {
            setConfirmation(true)
        } else {
            closeModal()
        }
    }, [formik.dirty, closeModal])

    const acceptConfirmation = useCallback(() => {
        closeModal()
        setConfirmation(false)
    }, [closeModal])

    const rejectConfirmation = useCallback(() => {
        setConfirmation(false)
    }, [])

    useEffect(() => {
        if (!isOpen) {
            setMode('main')
        }
    }, [isOpen])

    // Сброс формы при открытии модалки или изменении event
    useEffect(() => {
        if (isOpen) {
            formik.resetForm({ values: getInitialValues(event) })
        }
    }, [isOpen, event])

    const renderLi = ({ name, value, icon }) => {
        const selected = value === mode
        return (
            <li
                onClick={() => setMode(value)}
                className={cn(styles.modalMenuItem, {
                    [styles.selectedMenuItem]: selected
                })}
            >
                {icon()}
                {name}
            </li>
        )
    }

    const renderTab = () => {
        switch (mode) {
            case 'main': return <Main />
            case 'participants': return <Participants />
            case 'responsible': return <Responsible />
            case 'members_employees': return <ParticipantsEmployees />
            case 'parameters': return <Parameters />
            default: return
        }
    }

    return (
        <EventListContext.Provider value={{ closeModal: handleClose, event, filters, formik, addMode }}>
            <Modal
                open={isOpen}
                onClose={handleClose}
                classNames={{ modal: styles.modalMain }}
                closeOnOverlayClick={true}
                closeOnEsc={true}
                showCloseIcon={true}
                animationDuration={1}
                center
            >
                <div className={styles.modalContent}>
                    <div className={styles.modalMenu}>
                        <ul>{EventsListModalModes.map(renderLi)}</ul>
                    </div>
                    {renderTab()}
                </div>
                {confirmation && (
                    <Confirmation
                        title="Закрыть без сохранения изменений?"
                        acceptConfirmation={acceptConfirmation}
                        rejectConfirmation={rejectConfirmation}
                    />
                )}
                {conflict && (
                    <Confirmation
                        title={conflict.message || 'На указанный период место проведения уже занято.'}
                        confirmation={`${formatConflicts(conflict.conflicts)} Сохранить всё равно?`}
                        acceptConfirmation={handleForceSave}
                        rejectConfirmation={() => setConflict(null)}
                    />
                )}
            </Modal>
        </EventListContext.Provider>
    )
}